import { combineReducers } from 'redux';
import * as commonActions from '../actions';
import ckuDashboard from './CkuDashboard/reducers';
import sndDashboard from './SndDashboard/reducers';
import helpReducer from './Help/reducers';
import * as helpReducerContent from './Help/reducers';

export const AMOUNT_UNIT = 100000;
export const COUNTRY = 'COUNTRY';
export const REGION = 'REGION';
export const AREA = 'AREA';
export const TERRITORY = 'TERRITORY';

export const userReducer = (state = null, action) => {
  switch (action.type) {
    case commonActions.ME_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  me: userReducer,
  cku: ckuDashboard,
  snd: sndDashboard,
  help: helpReducer
});

export function getMe(state) {
  return state.me;
}

export const getHelpSummary = state => helpReducerContent.getHelpSummary(state);
